import React from 'react';
import styled from 'styled-components';
import { array } from 'prop-types';
import { SubBodyText } from '../Text/Heading';
import Icon from '../Icon';
import BreadcrumbLink from './BreadcrumbLink';

const List = styled.ul`
  display: flex;
  padding: 0;
  list-style: none;
  margin: 0;
`;

const Item = styled.li`
  list-style: none;
`;

const Separator = styled.li`
  display: flex;
  margin: 4px 4px;
  user-select: none;
  align-items: center;
  color: ${({ theme }) => theme.colors.greyDark};
`;

const insertSeparators = (items, separator) => {
  return items.reduce((accumulate, current, index) => {
    if (index < items.length - 1) {
      accumulate = accumulate.concat(
        current,
        <Separator aria-hidden key={`breadcrumbs-separator-${index}`}>
          {separator || <Icon icon="KeyboardArrowRight" fontsize="normal" />}
        </Separator>
      );
    } else {
      accumulate.push(current);
    }
    return accumulate;
  }, []);
};

const transformToItems = navigations => {
  return navigations.map((navigation, index) => {
    const { label, link } = navigation;
    let content;
    if (index === navigations.length - 1) {
      content = <SubBodyText color="greyDarker">{label}</SubBodyText>;
    } else {
      const isFirst = index === 0;
      content = <BreadcrumbLink label={label} link={link} isFirst={isFirst} />;
    }
    return <Item key={`breadcrumbs-item-${index}`}>{content}</Item>;
  });
};

const Breadcrumbs = ({ navigations = [] }) => {
  const items = transformToItems(navigations);
  return <List id="breadcrumbs">{insertSeparators(items)}</List>;
};

Breadcrumbs.propTypes = {
  navigations: array,
};

export default Breadcrumbs;
